
export const CSS_CONSTANTS = {
   BORDER_RADIUS: '0.5rem',
   MAIN_HEADING_3: '1.2rem', 
   LABEL_HEADING_SIZE: '1.1rem',
    LABEL_VALUE_SIZE: '1rem',
    ICON_SIZE: '1.8rem',
}